import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=3ec4f9c3&scoped=true&"
import script from "./RadioBox.vue?vue&type=script&lang=js&"
export * from "./RadioBox.vue?vue&type=script&lang=js&"
import style0 from "./RadioBox.vue?vue&type=style&index=0&id=3ec4f9c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4f9c3",
  null
  
)

export default component.exports